<template>
  <PopModal ref="modal" :title="title">
    <van-form @submit="save">
      <van-field
        v-model.trim="addressInfo.receiver"
        :label="$t('收货人')"
        :placeholder="$t('请输入收货人')"
      />
      <van-field
        v-model.trim="addressInfo.phone"
        :label="$t('电话号码')"
        :placeholder="$t('请输入电话号码')"
      />
      <van-field
        v-model.trim="addressInfo.postalCode"
        :label="$t('邮政编码')"
        :placeholder="$t('请输入邮政编码')"
      />
      <van-field
        v-model.trim="addressInfo.province"
        :label="$t('省份')"
        :placeholder="$t('请输入省份')"
        :rules="[
          {
            required: true,
            message: $t(`please_input`) + $t('province')
          }
        ]"
      />
      <van-field
        v-model.trim="addressInfo.city"
        :label="$t('城市')"
        :placeholder="$t('请输入城市')"
        :rules="[
          {
            required: true,
            message: $t('请输入城市')
          }
        ]"
      />
      <van-field
        v-model.trim="addressInfo.district"
        :label="$t('地区')"
        :placeholder="$t('请输入地区')"
        :rules="[
          {
            required: true,
            message: $t('请输入地区')
          }
        ]"
      />
      <van-field
        v-model.trim="addressInfo.addressDetail"
        :label="$t('具体地址')"
        :placeholder="$t('请输入具体地址')"
      />
      <van-field :label="$t('是否默认')" :placeholder="$t('是否默认')">
        <template #input>
          <van-switch
            v-model="addressInfo.isDefault"
            active-color="#ee0a24"
            inactive-color="#dcdee0"
            size="20"
          />
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button block native-type="submit" round small type="primary">
          {{ $t("保存") }}
        </van-button>
      </div>
    </van-form>
  </PopModal>
</template>
<script>
import { save } from "@/api/user.address";
import PopModal from "@/components/PopModal.vue";

export default {
  components: {
    PopModal,
  },
  data() {
    return {
      title: "",
      addressInfo: {
        id: null,
        name: null,
        tel: null,
        postalCode: null,
        address: null,
        addressDetail: null,
        isDefault: true
      }
    };
  },
  methods: {
    show(addressInfo) {
      this.title = addressInfo ? this.$t("编辑地址") : this.$t("新地址");
      this.addressInfo = addressInfo || {};
      this.$refs.modal.show();
    },
    save() {
      save(this.addressInfo).then(() => {
        this.$message.success(this.$t("保存成功"));
        this.$refs.modal.hide();
        this.$emit("save");
      });
    }
  }
};
</script>
